const url = {
    dev: {
        // publicUrl: 'http://127.0.0.1:9411/admin',
        // manageUrl: 'http://127.0.0.1:9411/admin'
        publicUrl: 'https://pugong.cxc-group.com/api/admin',
        manageUrl: 'https://pugong.cxc-group.com/api/admin'
    },
    pro: {
        publicUrl: 'https://pugong.cxc-group.com/api/admin',
        manageUrl: 'https://pugong.cxc-group.com/api/admin'
    }
}

export const get = () => {
    if(process.env.NODE_ENV === 'production'){
        return url['pro']
    }else{
        return url['dev']
    }
}
